import { render, staticRenderFns } from "./DetailFixedAssetInternal.vue?vue&type=template&id=52b0e868"
import script from "./DetailFixedAssetInternal.vue?vue&type=script&lang=js"
export * from "./DetailFixedAssetInternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports